import { useState } from "react";
import PropTypes from "prop-types";
import { Box, Button, FormControl, FormControlLabel, Paper, Radio, RadioGroup, Typography } from "@mui/material";
import { useRewampLocalization, useRewampT } from "../localisation";
import { LOGIN_CARD_MAX_WIDTH } from "./RewampOnboardingLayout";

const OPTIONS = [
  { value: "farmer", labelKey: ["IDENTITY_PICKER.FARMER", "Farmer"] },
  { value: "self", labelKey: ["IDENTITY_PICKER.SELF", "Self"] },
];

export default function AgentIdentityPicker({ onSelect }) {
  useRewampLocalization(["farmerVerify"]);
  const tRewamp = useRewampT();
  const [choice, setChoice] = useState("");

  return (
    <Box sx={{ width: "100%", maxWidth: LOGIN_CARD_MAX_WIDTH, mx: "auto" }}>
      <Paper
        variant="onboardingCard"
        component="form"
        noValidate
        onSubmit={(event) => {
          event.preventDefault();
          if (choice) onSelect(choice);
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, textAlign: "center" }}>
          <Typography
            variant="sectionHeader"
            component="h2"
            id="identity-picker-title"
            sx={{ fontWeight: 700, color: "neutral.headings" }}
          >
            {tRewamp("IDENTITY_PICKER.TITLE", "Select an Account")}
          </Typography>
          <Typography variant="body2" sx={{ color: "neutral.body" }}>
            {tRewamp("IDENTITY_PICKER.SUBTITLE", "To process further, select an account to proceed")}
          </Typography>
        </Box>
        <FormControl component="fieldset" sx={{ width: "100%" }}>
          <RadioGroup
            row
            name="agent-identity"
            aria-labelledby="identity-picker-title"
            value={choice}
            onChange={(event) => setChoice(event.target.value)}
            sx={{ width: "100%", flexWrap: "nowrap", borderBottom: 2, borderColor: "divider" }}
          >
            {OPTIONS.map(({ value, labelKey }) => (
              <FormControlLabel
                key={value}
                value={value}
                control={<Radio color="primary" sx={{ p: 0 }} />}
                label={tRewamp(...labelKey)}
                sx={{ flex: "1 1 0", m: 0, pb: 1.5, gap: 1, justifyContent: "flex-start", minWidth: 0 }}
              />
            ))}
          </RadioGroup>
        </FormControl>
        <Button type="submit" variant="primary" size="submit" disabled={!choice}>
          {tRewamp("IDENTITY_PICKER.PROCEED", "Proceed")}
        </Button>
      </Paper>
    </Box>
  );
}

AgentIdentityPicker.propTypes = {
  onSelect: PropTypes.func.isRequired,
};
